import { PageLayout } from '@/components/layout/PageLayout';
import { SeoHead } from '@/components/seo/SeoHead';
import type { DemoJobDetails } from './jobDescriptionDemoData';
import styles from './JobDescriptionDemoPage.module.css';

/**
 * Static demo job page for `/1` and `/2` — mirrors Flutter WebJobDescriptionPage1 / 2
 * (presentation/web_job_description/): the page title is the role (Flutter `Title`), the
 * Seo.head meta tags are title / description / keywords, then header, the hard-coded job text
 * and footer. The text is shown as-is, like Flutter (no translation, no API calls).
 */
export function JobDescriptionDemoPage({ job }: { job: DemoJobDetails }) {
  return (
    <PageLayout>
      <SeoHead
        title={job.role}
        meta={[
          { name: 'title', content: job.role },
          { name: 'description', content: job.responsibilities.join(', ') },
          { name: 'keywords', content: job.keywords.join(', ') },
        ]}
      />

      <div className={styles.page}>
        <article className={styles.card}>
          <p className={styles.posted}>Posted {job.posted}</p>

          <h1 className={styles.heading}>Job Description</h1>
          <p>Management Level: {job.managementLevel}</p>
          <p>Work Experience: {job.experience}</p>
          <p>Work location: {job.location}</p>

          <h2 className={`${styles.heading} ${styles.section}`}>Job Requirements</h2>
          <p>Project Role: {job.role}</p>
          <p className={styles.bold}>Responsibilities:</p>
          {job.responsibilities.map((responsibility) => (
            <p key={responsibility}>- {responsibility}</p>
          ))}
          <p className={styles.gapSmall}>Skills: {job.skills.join(', ')}</p>

          <p className={styles.gapLarge}>Educational Qualification: {job.education}</p>
          <p>Salary: {job.salary}</p>
          <p className={styles.gapSmall}>Industry: {job.industry}</p>
          <p>Department: {job.department}</p>
          <p>Employment Type: {job.employmentType}</p>
        </article>
      </div>
    </PageLayout>
  );
}
